'use client' 
import { TopicDates } from './'
import Live from '@/assets/images/icons/recently-launched.svg'
import UpNext from '@/assets/images/icons/up-next.svg'
import CurrentlyWorkingOn from '@/assets/images/icons/currently-working-on.svg'
import InDiscovery from '@/assets/images/icons/in-discovery.svg'

interface RoadMapCalenderProps {
    data: any | null;
}

const RoadMapCalender: React.FC<RoadMapCalenderProps> = ({ data }) => {

    const toDate = (value: string) => new Date(value);
    const diffDays = (a: Date, b: Date) => (a.getTime() - b.getTime()) / (1000 * 60 * 60 * 24);
    const formatMMMYY = (date: Date) =>
        new Intl.DateTimeFormat('en-NZ', { month: 'short', year: '2-digit' }).format(date).replace(',', '');

    const inDiscovery =[] as any
    const upNext =[] as any
    const currentlyWorkingOn =[] as any
    const currentCampaigns =[] as any


    const phaseColor = (type: any) => {
        switch(type) {
            case 'jade':
                return {background: "bg-jade", text:"text-white", dot:"bg-lightjade"}
            break;
            case 'orange':
                return {background: "bg-orange", text:"text-white", dot:"bg-lightorange"}
            break;
            case 'rose gold':
                return {background: "bg-rosegold", text:"text-jade", dot:"bg-lightrosegold"}
            break;
            case 'grey':
                return {background: "bg-roadmapdarkgrey", text:"text-jade", dot:"bg-lightroadmapdarkgrey"}
            break;
            case 'blue':
                return {background: "bg-lightroadmapblue", text:"text-white", dot:"bg-lightblue"}
            break;
            default:
        }
    }

    data?.map((data: any)=>{
        data.data?.slices[0].primary.items?.map((item: any)=>{
            if(item.date_start !== null && item.date_end !== null) {
                let colorSet = [] as any
                switch(item.status) {
                    case 'In discovery':
                        colorSet = phaseColor(data.data.category_colour?.toLowerCase()) as any
                        item.colour = data.data.category_colour?.toLowerCase();
                        item.background = colorSet?.background;
                        item.text = colorSet?.text;
                        item.dot = colorSet?.dot;
                        inDiscovery.push(item)
                    break;
                    case 'Up next':
                        colorSet = phaseColor(data.data.category_colour?.toLowerCase()) as any
                        item.colour = data.data.category_colour?.toLowerCase();
                        item.background = colorSet?.background;
                        item.text = colorSet?.text;
                        item.dot = colorSet?.dot;
                        upNext.push(item)
                    break;
                    case 'Currently working on':
                        colorSet = phaseColor(data.data.category_colour?.toLowerCase()) as any
                        item.colour = data.data.category_colour?.toLowerCase();
                        item.background = colorSet?.background;
                        item.text = colorSet?.text;
                        item.dot = colorSet?.dot;
                        currentlyWorkingOn.push(item)
                    break;
                    case 'Current campaigns':
                        colorSet = phaseColor(data.data.category_colour?.toLowerCase()) as any
                        item.colour = data.data.category_colour?.toLowerCase();
                        item.background = colorSet?.background;
                        item.text = colorSet?.text;
                        item.dot = colorSet?.dot;
                        currentCampaigns.push(item)
                    break;
                }
            }
        })
    })

    // Get start and end dates 

    const dateRanges =[]  as any
    data?.map((data: any)=>{
        // console.log(data)
        data.data?.slices[0].primary.items?.map((item: any)=>{
        if(item.date_start !== null && item.date_end !== null) {
            dateRanges.push({start: item.date_start, end: item.date_end})
        }
    })})

    const earliestStartDate = new Date(Math.min(...dateRanges.map((range: any) => toDate(range.start).getTime())));
    const latestEndDate = new Date(Math.max(...dateRanges.map((range: any) => toDate(range.end).getTime())));

    const daysDifference = Math.ceil(diffDays(latestEndDate, earliestStartDate));

    // Create an array to store all months
    const monthsList: string[] = [];
    

    // Add each month to the array
    const monthCursor = new Date(earliestStartDate.getFullYear(), earliestStartDate.getMonth(), 1);
    const monthEnd = new Date(latestEndDate.getFullYear(), latestEndDate.getMonth(), 1);
    while (monthCursor <= monthEnd) {
        monthsList.push(formatMMMYY(monthCursor));
        monthCursor.setMonth(monthCursor.getMonth() + 1);
    }

    const showDots = (id: any, dot: any) => {
        // console.log(dot, id)
        const selector = document.querySelectorAll('div.'+id);
    
        selector.forEach(element => {
            element.classList.toggle("hide");
        });
        dot.children[0]?.classList.toggle("on");
    }
    
    return (
        <section className="font-fellix text-jade w-full">
            <div className="grid grid-cols-12 gap-0">
                <div className="col-span-12 md:col-span-4">
                    <h3 className="text-[28px] font-semibold">Calendar</h3>
                </div>
                <div className="col-span-12 md:col-span-8 flex justify-end pr-4 md:pr-8 lg:pr-12">
                    <ul className="m-0 p-0">
                        {data?.map((item: any, index: number)=>{
                            const bgColour = phaseColor(item.data.category_colour?.toLowerCase())
                            return (
                                <li key={index} className="inline-block mr-[15px] text-[12px] cursor-pointer;" onClick={(e)=>showDots("topic-dates-"+item.data.category_colour?.toLowerCase().replace(" ",""), e.target)}>
                                    <span className={` w-[16px] h-[16px] rounded-[8px] inline-block mr-[5px] relative top-[4px] ${bgColour?.background}`}></span> 
                                    {item.data.category_heading}
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div> 
            <div className=" mx-0 my-[40px] bg-roadmapgrey rounded-[10px] px-[20px] py-[0] overflow-x-scroll relative">
                <div className="sticky z-[5] top-0 ml-[160px] pr-[20px] py-0 pl-0 bottom-0 flex justify-between" style={{width: `${(monthsList.length /12) * 1380}px`}}>
                    {monthsList.map((item, index)=>{
                        return (<div className="text-[14px] leading-[30px] pt-[16px] px-[10px] pb-[0] inline-flex border-l-[1px] border-l-deepjade/30 h-full" key={index}>{item}</div>)
                    })}
                </div>
                <div className="absolute z-1 top-0 ml-[160px] pr-[20px] py-0 pl-0 bottom-0 flex justify-between" style={{width: `${(monthsList.length /12) * 1380}px`}}>
                    {monthsList.map((item, index)=>{
                        return (<div className="text-[14px] leading-[30px] pt-[16px] px-[10px] pb-[0] inline-flex border-l-[1px] border-l-deepjade/30 h-full" key={index}>{item}</div>)
                    })}
                </div>
                <div className="py-16 font-semibold" style={{width: `${(monthsList.length /12) * 1420}px`}}>
                    {inDiscovery.length > 0 ? 
                    <div className="pb-[10px] flex items-start relative">
                        <div className="inline-flex w-[150px] border-t-[1px] border-t-deepjadeborder/50 sticky left-[0] z-[90]">
                            <div className="mt-[10px] bg-white rounded-[10px] rounded-tl-none rounded-tr-none w-full p-[10px] relative h-[160px]"><p>In discovery</p><InDiscovery  className="w-12 h-12 absolute bottom-4"/></div>   
                        </div>
                        <div className="inline-flex pl-[20px] pt-[10px] w-[calc(_100%_-_150px)] border-t-deepjade/30 border-t-[1px]">
                            <div className="w-full">
                                {inDiscovery?.map((item: any, index: number)=>{
                                    return <TopicDates data={item} key={index} open={index} daysDifference={daysDifference} earliestStartDate={earliestStartDate}/>
                                })}
                            </div>
                        </div>
                    </div>
                    :<></>}
                    {upNext.length > 0 ? 
                    <div className="pb-[10px] flex items-start relative">
                        <div className="inline-flex w-[150px] border-t-[1px] border-t-deepjadeborder/50 sticky left-[0] z-[90]">
                            <div className="mt-[10px] bg-white rounded-[10px] rounded-tl-none rounded-tr-none w-full p-[10px] relative h-[160px]"><p>Up next</p><UpNext  className="w-12 h-12 absolute bottom-4"/></div>   
                        </div>
                        <div className="inline-flex pl-[20px] pt-[10px] w-[calc(_100%_-_150px)] border-t-deepjade/30 border-t-[1px]">
                            <div className="w-full">
                                {upNext?.map((item: any, index: number)=>{
                                    return <TopicDates data={item} key={index} open={index} daysDifference={daysDifference} earliestStartDate={earliestStartDate}/>
                                })}
                            </div>
                        </div>
                    </div>
                    :<></>}
                    {currentlyWorkingOn.length > 0 ? 
                    <div className="pb-[10px] flex items-start relative">
                        <div className="inline-flex w-[150px] border-t-[1px] border-t-deepjadeborder/50 sticky left-[0] z-[90]">
                            <div className="mt-[10px] bg-white rounded-[10px] rounded-tl-none rounded-tr-none w-full p-[10px] relative h-[160px]"><p>Currently working on</p><CurrentlyWorkingOn  className="w-12 h-12 absolute bottom-4"/></div>   
                        </div>
                        <div className=" inline-flex pl-[20px] pt-[10px] w-[calc(_100%_-_150px)] border-t-deepjade/30 border-t-[1px]">
                            <div className="w-full">
                                {currentlyWorkingOn?.map((item: any, index: number)=>{
                                    return <TopicDates data={item} key={index} open={index} daysDifference={daysDifference} earliestStartDate={earliestStartDate}/>
                                })}
                            </div>
                        </div>
                    </div>
                    :<></>}
                    {currentCampaigns.length > 0 ? 
                    <div className="pb-[10px] flex items-start relative">
                        <div className="inline-flex w-[150px] border-t-[1px] border-t-deepjadeborder/50 sticky left-[0] z-[90]">
                            <div className="mt-[10px] bg-white rounded-[10px] rounded-tl-none rounded-tr-none w-full p-[10px] relative h-[160px]"><p>Live</p><Live className="w-12 h-12 absolute bottom-4"/></div>   
                        </div>
                        <div className="inline-flex pl-[20px] pt-[10px] w-[calc(_100%_-_150px)] border-t-deepjade/30 border-t-[1px]">
                            <div className="w-full">
                                {currentCampaigns?.map((item: any, index: number)=>{
                                    return <TopicDates data={item} key={index} open={index} daysDifference={daysDifference} earliestStartDate={earliestStartDate}/>
                                })}
                            </div>
                        </div>
                    </div>
                    :<></>}
                </div>
            </div>
        </section>
    )

}

export default RoadMapCalender;
